module.exports = __webpack_public_path__ + "img/add_plus.25e36a54.svg";